import React from 'react'
import PropTypes from 'prop-types'

const SelectChip = ({ object, name, onChange, readOnly = false, valueList = [] }) => {
    const currentValue = object[name];
    return (
        <div>
            {valueList.map((option, index) => {
                const selected = option.value === currentValue
                return (
                    <div
                        className={selected ? 'chip chip-selected' : 'chip'}
                        key={index}
                        onClick={() => {
                            if (readOnly) {
                                return
                            }
                            onChange(name, option.value)
                        }}
                    >{option.label}</div>
                )
            })}
        </div>
    )
}

SelectChip.propTypes = {
    object: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    valueList: PropTypes.array,
}

export default SelectChip



// WEBPACK FOOTER //
// ./src/modules/form/component/SelectChip.js